import { FETCH_BANK_ACCOUNTS } from "./actions";
import { SET_BANK_ACCOUNTS, SET_ERROR, SET_FETCHING } from "./mutations";
import apiService from "../../../services/api";

const state = {
  isFetching: false,
  data: null,
  error: null
};

const actions = {
  async [FETCH_BANK_ACCOUNTS](context) {
    context.commit(SET_FETCHING, true);
    context.commit(SET_ERROR, null);
    try {
      context.commit(SET_BANK_ACCOUNTS, await apiService.getBankAccounts());
    } catch (error) {
      context.commit(SET_ERROR, error);
    }
    context.commit(SET_FETCHING, false);
  }
};

const mutations = {
  [SET_FETCHING](state, status) {
    state.isFetching = status;
  },
  [SET_ERROR](state, error) {
    state.error = error;
  },
  [SET_BANK_ACCOUNTS](state, user) {
    state.data = {
      ...user
    };
  }
};

export default {
  state,
  actions,
  mutations
};
